import {
  REQUEST_SPEEDING_POINTS,
  RESPONSE_SPEEDING_POINTS,
  REQUEST_SPEEDING_POINTS_FAILURE,
  CLEAR_SPEEDING_POINTS,
} from "../actions/mapSpeedingPointsActions";

import { states } from "./queriesStates";

const initialState = {
  mapSpeedingPointsDataState: states.NOT_REQUESTED,
  speedingPoints: [],
  errors: null,
};

const mapSpeedingPointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SPEEDING_POINTS:
      return Object.assign({}, state, {
        mapSpeedingPointsDataState: states.REQUEST,
      });
    case RESPONSE_SPEEDING_POINTS:
      return Object.assign({}, state, {
        mapSpeedingPointsDataState: states.READY,
        speedingPoints: action.data.points,
        errors: [],
      });
    case REQUEST_SPEEDING_POINTS_FAILURE:
      return Object.assign({}, state, {
        mapGpsJamminDataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_SPEEDING_POINTS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapSpeedingPointsReducer;
